import React, {Component, useState} from 'react';
import { Button, Container, Row, Col, FormControl, FormLabel, Alert, FormSelect } from 'react-bootstrap';
import ClientDataService from "./services/client.service";
import { Navigate } from 'react-router-dom';
import { useParams } from "react-router-dom";
import { useEffect } from 'react';
import { IoIosArrowBack } from "react-icons/io";
import { PageHeader } from './AuxiliaryFunctions';

var newDate = new Date()
var gtDate = newDate.getDate().toString().padStart(2,'0') + '-' + (newDate.getMonth()+1).toString().padStart(2,'0') + '-' + newDate.getFullYear()

const EditClientsPage = (props) => {    
  let params = useParams();
  const [showerror, setShowerror] = useState(false);
  const [showsuccess, setShowsuccess] = useState(false);
  const [errmessage, setErrmessage] = useState('');
  const [succmessage, setSuccmessage] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const [clientid, setClientid] = useState(params.id);
  const [clientname, setClientname] = useState('');
  const [contactperson, setContactperson] = useState('');
  const [contactphone, setContactphone] = useState('');
  const [contactemail, setContactemail] = useState('');

  const onChangeClientName = (e) => {
    setClientname(e.target.value);
  } 

  const onChangeContactPerson = (e) => {
    setContactperson(e.target.value);
  } 
  
  const onChangeContactPhone = (e) => {
    setContactphone(e.target.value);
  } 

  // This has a slight issue. It does not update when selecting all the text and pressing DEL key..
  // It works with BACKSPACE if letters are removed one by one
  // Or with DEL also one by one from the beginning of the text
  const onChangeContactEmail = (e) => {
    setContactemail(e.target.value);    
  } 

  const handleValidations = (e) => {
    if (clientname.length == 0 || contactperson.length ==0) {
      setErrmessage('There are empty required fields.');
      setShowerror(true);
      return;
    }
    if (contactemail) {
      if (!/\S+@\S+\.\S+/.test(contactemail)) {
        setErrmessage('Email is invalid.');
        setShowerror(true);
        return;
      }      
    }
    saveClient();
  }

  useEffect(() => {
    retrieveClient(clientid);  
  }, [])

  const retrieveClient = (clientid) => {
    ClientDataService.get(clientid)
      .then(response => {
        setClientname(response.data.clientname);
        setContactperson(response.data.clientcontactperson);
        setContactphone(response.data.clientcontactphone);
        setContactemail(response.data.clientcontactemail);
        console.log(response.data);
      })
      .catch(e => {
        console.log(e);
      });
  }


  let saveClient = ()  =>{   
    var data = {
        clientname: clientname,
        clientcontactperson: contactperson,
        clientcontactphone: contactphone,
        clientcontactemail: contactemail,
    }    
    
    ClientDataService.update(params.id, data)
    .then(response => {
      setSubmitted(true);
      setSuccmessage('Client has been updated. Redirecting to client list...');
      setShowsuccess(true);
      //window.location.assign('/clients');
    })
    .catch(e => {
      console.log(e);
    })        
  }  

  const goToClientsList = (e) => {
    window.location.assign('/clients')
  }
  
  return (
    <>
      <Container style={{width:"80%"}}>
        <PageHeader />
        <Container>
          <Row className='mb-2'>
            <h4 className='mb-4' style={{width: "100%", textAlign: "center", marginLeft: "0%", color: "green" }}>Edit Client</h4>
            <Col lg={true}>
              <FormLabel className='mb-2'>Client Name:</FormLabel>       
              <FormControl style={{maxWidth:"300px"}} type="text" name="clientname" id="clientname" onChange={onChangeClientName} defaultValue={clientname}></FormControl>
            </Col>

            <Col lg={true}>
              <FormLabel className='mb-2'>Contact Person:</FormLabel>       
              <FormControl style={{maxWidth:"300px"}} type="text" name="contactperson" id="n" onChange={onChangeContactPerson} defaultValue={contactperson}></FormControl>
            </Col>          

            <Col lg={true}>
              <FormLabel className='mb-2'>Phone:</FormLabel>       
              <FormControl style={{maxWidth:"300px"}} type="text" name="contactphone" id="contactphone" onChange={onChangeContactPhone} defaultValue={contactphone}></FormControl>
            </Col>  

            <Col lg={true}>
              <FormLabel className='mb-2'>Email:</FormLabel>       
              <FormControl style={{maxWidth:"300px"}} type="text" name="contactemail" id="contactemail" onChange={onChangeContactEmail} defaultValue={contactemail}></FormControl>
            </Col>  

          </Row>
          <hr/>
          <Row className='mb-2'>
            <Col className='col-md-3'>
              <Button id='saveItem' onClick={handleValidations}>Save Client</Button>            
              <Button className='m-2' id='backToClientsList' onClick={goToClientsList}><IoIosArrowBack/></Button>            
            </Col>
          </Row>  
          {showerror && (
            <Alert variant="danger" onClose={() => setShowerror(false)} dismissible>
              <Alert.Heading>Error</Alert.Heading>
              <p>{errmessage}</p>
            </Alert>      
          )}
          {showsuccess && (
            <Alert variant="success" onClose={() => setShowsuccess(false)} dismissible>
              <Alert.Heading>Done</Alert.Heading>
              <p>{succmessage}</p>
            </Alert>      
          )}     
          {submitted ? (<Navigate push to="/clients"/>) : null }                                     
        </Container>  
      </Container>  
    </>
  )

}

export default EditClientsPage;

